import React, { useEffect, useState } from "react";
// Material Dashboard 2 React components

// Components
import FilterButton from "components/Buttons/FilterButton";
import Constants, { Icons, Colors, ButtonTitles } from "utils/Constants";
import pxToRem from "assets/theme/functions/pxToRem";
import MDTypography from "components/MDTypography";
import { IconButton } from "@mui/material";
import MDBox from "components/MDBox";
import { timeAgo, identifyNotificationRoute } from "utils/methods/methods";
import { Link } from "react-router-dom";

export default function OrderDetailsData(notificationsData, handleMarkAsRead) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (notificationsData) {
      const tempRows = notificationsData?.map((element) => {
        const temp = {
          equipmentname: (
            <MDBox display="flex" flexDirection="column">
              <MDBox display="flex" flexDirection="row">
                <IconButton aria-label="fingerprint" sx={{ marginLeft: pxToRem(-8) }}>
                  {Icons.PERSON}
                </IconButton>
                <MDTypography
                  sx={{
                    color: "#101828",
                    fontSize: pxToRem(14),
                    fontWeight: "400",
                    marginLeft: pxToRem(2),
                    marginTop: pxToRem(8),
                  }}
                >
                  From:{" "}
                  {`${element?.notification?.sender?.firstName} ${element?.notification?.sender?.lastName}`}
                </MDTypography>
                <IconButton sx={{ marginLeft: pxToRem(8) }}>{Icons.TIME}</IconButton>
                <MDTypography
                  sx={{
                    color: "#101828",
                    fontSize: pxToRem(14),
                    fontWeight: "400",
                    marginLeft: pxToRem(2),
                    marginTop: pxToRem(8),
                  }}
                >
                  {timeAgo(element?.createdAt)}
                </MDTypography>
              </MDBox>
              <Link
                to={identifyNotificationRoute(
                  element?.notification?.module,
                  element?.notification?.actionUrl
                )}
              >
                <MDTypography
                  sx={{
                    color: "#101828",
                    fontSize: pxToRem(16),
                    fontWeight: element?.isRead ? "400" : "700",
                    marginTop: pxToRem(5),
                  }}
                >
                  {element?.notification?.title}
                </MDTypography>
                <MDBox>
                  <MDTypography
                    sx={{
                      color: "#101828",
                      fontSize: pxToRem(14),
                      fontWeight: element?.isRead ? "400" : "700",
                      marginTop: pxToRem(5),
                    }}
                  >
                    {element?.notification?.body.length > 250
                      ? `${element?.notification?.body.slice(0, 250)}...`
                      : element?.notification?.body}
                  </MDTypography>
                </MDBox>
              </Link>
              {!element?.isRead && (
                <MDBox display="flex" justifyContent="flex-start">
                  <FilterButton
                    title={ButtonTitles.MARK_AS_READ}
                    variant="none"
                    color={Colors.PRIMARY}
                    icon={Icons.ACCEPT3}
                    mt={0}
                    ml={pxToRem(-18)}
                    handleClick={() => handleMarkAsRead(element[Constants.MONGOOSE_ID])}
                  />
                </MDBox>
              )}
            </MDBox>
          ),
        };
        return temp;
      });
      setRows([...tempRows]);
    }
  }, [notificationsData]);
  return {
    columns: [
      {
        accessor: "equipmentname",
        width: "10%",
        align: "left",
      },
    ],
    rows,
  };
}
